/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useCallback, useEffect } from "react";
import "../css/welcome.css";
import callApi from "../utils/apiCaller";
import Swal from "sweetalert2";
import { Link as RoterLink } from "react-router-dom";
import {
  DeleteMajor,
  DomainNewMajor,
  DuplicateMinor,
  ExchangeMajor,
  ExistingInventoryMajor,
} from "@shopify/polaris-icons";
import moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Button, Card, Checkbox, Heading } from "@shopify/polaris";
import config from "../config/config";
import { actFetchShowLoadingPage } from "../actions/index";

import { useDispatch, useSelector } from "react-redux";
import Step1 from "./Welcome/Step1";
import Step2 from "./Welcome/Step2";
import Step3 from "./Welcome/Step3";
import Step4 from "./Welcome/Step4";
import UserTour from "./UserTour";
import Step0 from "./Welcome/Step0";

const Welcome = () => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(
    config.checkLocalStorage
      ? localStorage.getItem("paypal-" + config.shop + "-step") === null
        ? 1
        : parseInt(localStorage.getItem("paypal-" + config.shop + "-step"))
      : "1"
  );
  const [checkDisabled, setcheckDisabled] = useState(false);
  const [checkProcess, setCheckProcess] = useState(false);
  const [type, settype] = useState("");
  const [note, setnote] = useState("");
  const [progressWidth, setProgressWidth] = useState(0);
  const listAccounts = useSelector((state) => state.listPayPalAccounts);
  const dataSettings = useSelector((state) => state.dataSettings);
  const [openModalSubmitDemo, setOpenModalSubmitDemo] = useState(false);

  const processOldOrders = () => {
    if (checkProcess) {
      dispatch(actFetchShowLoadingPage(true));
      let params = {
        action: "processGetOldOrders",
        oldOrderRange: "60",
        store: config.shop,
      };
      callApi("get", params).then(async (res) => {
        dispatch(actFetchShowLoadingPage(false));
        setStep(step + 1);
      });
    } else {
      setStep(step + 1);
    }
  };

  const savePoll = () => {
    console.log(type, note);
    if (type !== "") {
      let params = {
        action: "clickReview",
        type: type,
        note: note,
      };
      callApi("get", params).then(async (res) => {});
    }
    setStep(step + 1);
  };
  const changePoll = (value) => {
    settype(value.type);
    setnote(value.note);
    if (value.type !== "") {
      if (
        value.type == "friend_colleague" ||
        value.type == "search_engine" ||
        value.type == "blogs" ||
        value.type == "youtube"
      ) {
        if (value.note == "") {
          setcheckDisabled(true);
        } else {
          setcheckDisabled(false);
        }
      } else {
        setcheckDisabled(false);
      }
    }
  };

  const processChangeStep = (step) => {
    if (config.checkLocalStorage) {
      localStorage.setItem("paypal-" + config.shop + "-step", step + 1);
    }
    if (step === 3) {
      processOldOrders();
    } else if (step === 0) {
      savePoll();
    } else {
      setStep(step + 1);
    }
  };

  useEffect(() => {
    let params = {
      action: "updateWelcomStatus",
    };
    callApi("get", params).then(async (res) => {});
  }, []);

  useEffect(() => {
    let params = {
      action: "updateWelcomeStep",
      step: step,
    };
    callApi("get", params).then(async (res) => {});
  }, [step]);

  useEffect(() => {
    window.onmessage = function (e) {
      if (e.data.type === "paypalConnected") {
        let params = {
          action: "processCodePayPalReturn",
          code: e.data.code,
        };
        callApi("get", params).then(async (res) => {
          if (res.data.state === 1) {
            Swal.fire({
              icon: "success",
              title: "Successfully!",
              text: "Connect PayPal Account Successfully!",
              confirmButtonColor: "#0070ba",
              cancelButtonText: "No",
              showCancelButton: false,
              showCloseButton: true,
              timer: 3000,
            }).then((result) => {
              setStep(3);
            });
          }
        });
      }
    };
  }, []);

  return (
    <div style={{ marginTop: "20px" }} className="integration-page">
      <Card sectioned>
        <div
          className="col-4 col-md-4 col-xs-12 pb-5"
          style={{ float: "none", margin: "0 auto" }}
        >
          <div className="row">
            <div id="welcomewizard" className="form-horizontal form-wizard">
              <input
                type="hidden"
                name="_token"
                defaultValue="8ihPhbYCUafn2bz9h7AmOG0xBPtvx719wUkl9JmZ"
              />
              <div
                className="steps-progress"
                style={{ marginLeft: "12.5%", marginRight: "12.5%" }}
              >
                <div
                  className="progress-indicator"
                  style={{ width: progressWidth }}
                />
              </div>
              <ul>
                <li
                  onClick={() => setStep(1)}
                  className={
                    step > 1 ? "completed" : step === 1 ? "active" : ""
                  }
                >
                  <a href="#tab1" data-toggle="tab" aria-expanded="false">
                    <span>1</span>
                    <Heading>Welcome</Heading>
                  </a>
                </li>
                <li
                  onClick={() => setStep(2)}
                  className={
                    step > 2 ? "completed" : step === 2 ? "active" : ""
                  }
                >
                  <a href="#tab2" data-toggle="tab" aria-expanded="false">
                    <span>2</span> <Heading>Connect to Paypal</Heading>
                  </a>
                </li>
                <li
                  onClick={() => setStep(3)}
                  className={
                    step > 3 ? "completed" : step === 3 ? "active" : ""
                  }
                >
                  <a href="#tab3" data-toggle="tab" aria-expanded="true">
                    <span>3</span>
                    <Heading>Process old orders</Heading>
                  </a>
                </li>
                <li
                  onClick={() => setStep(4)}
                  className={
                    step > 4 ? "completed" : step === 4 ? "active" : ""
                  }
                >
                  <a href="#tab4" data-toggle="tab">
                    <span>4</span>
                    <Heading>Finish</Heading>
                  </a>
                </li>
              </ul>
              <div className="tab-content d-block">
                <div className="tab-panel">
                  {step === 0 ? <Step0 changePoll={changePoll} /> : null}
                </div>
                <div className="tab-panel">{step === 1 ? <Step1 /> : null}</div>
                <div className="tab-panel">{step === 2 ? <Step2 /> : null}</div>
                <div className="tab-panel">{step === 3 ? <Step3 /> : null}</div>
                <div className="tab-panel">{step === 4 ? <Step4 /> : null}</div>
                <div className="tab-panel">
                  {step === 3 ? (
                    <div className="text-center">
                      <Checkbox
                        label="Yes, I want to sync the last 60 days trackings to PayPal"
                        checked={checkProcess}
                        onChange={(newCheck) => setCheckProcess(newCheck)}
                      />
                      {listAccounts.length > 0 && dataSettings.submit_demo ? (
                        <div className="mt-4 text-center">
                          <Button
                            onClick={() => setOpenModalSubmitDemo(true)}
                            size="large"
                            fullWidth
                          >
                            Try syncing tracking numbers for some orders
                          </Button>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                <div className="text-center mt-4">
                  {step !== 4 ? (
                    <div className="mb-3">
                      <Button
                        disabled={checkDisabled}
                        size="large"
                        onClick={() => processChangeStep(step)}
                        fullWidth
                        primary
                      >
                        {step === 1
                          ? "Get Started"
                          : step === 0
                          ? "Submit & Get Started"
                          : "Next"}
                      </Button>
                    </div>
                  ) : null}
                  {step > 0 ? (
                    <RoterLink
                      to={{
                        pathname: config.pathName + "/home",
                        search: "?" + config.urlParamsValue,
                      }}
                    >
                      <Button size="large" fullWidth>
                        Skip & Finish
                      </Button>
                    </RoterLink>
                  ) : null}
                </div>
              </div>
            </div>
            <UserTour
              type="step"
              changeStatusModal={() => setOpenModalSubmitDemo(false)}
              openModal={openModalSubmitDemo}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Welcome;
